import axios from "axios";
import { anomalyRuleAPI, findingRuleAPI, params, header } from "../_api";

import {
  PERSIST_FILTER_DATA,
  PERSIST_ANOMALY_RULE,
  PERSIST_FINDING_RULE,
  PERSIST_ANOMALY_RULE_FILTER,
  FETCH_ALL_ANOMALY_RULE_SUCCESS,
  FETCH_ALL_ANOMALY_RULE_FAILURE,
  FETCH_All_FINDING_RULE_SUCCESS,
  FETCH_All_FINDING_RULE_FAILURE,
  CLEAR_ANOMALY_RULE_FILTER
} from "../_constants";

export const persistSelectedAnomalyRule = (anomalyRule) => {
  return {
    type: PERSIST_ANOMALY_RULE,
    payload: anomalyRule,
  };
};

export const persistAnomalyRuleFilter = (filter) => {
  return {
    type: PERSIST_ANOMALY_RULE_FILTER,
    payload: filter,
  };
};

const fetchAllAnomalyRuleSuccess = (data) => {
  return { type: FETCH_ALL_ANOMALY_RULE_SUCCESS, payload: data };
};

const fetchAllAnomalyRuleFailure = (error) => {
  return { type: FETCH_ALL_ANOMALY_RULE_FAILURE, payload: error };
};

export const fetchAllAnomalyRule = (machineType,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: anomalyRuleAPI,
      params: {
        ...params,
        machine_type:machineType,
        hmi_type:hmi_type,
        with_signals: true,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchAllAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAllAnomalyRuleFailure(errorMsg));
      });
  };
};

const fetchAllFindingRuleSuccess = (data) => {
  return { type: FETCH_All_FINDING_RULE_SUCCESS, payload: data };
};

const fetchAllFindingRuleFailure = (error) => {
  return { type: FETCH_All_FINDING_RULE_FAILURE, payload: error };
};

export const fetchAllFindingRule = () => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: findingRuleAPI,
      params: {
        ...params,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchAllFindingRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAllFindingRuleFailure(errorMsg));
      });
  };
};

export const persistSelectedFindingRule = (findingRule) => {
  return {
    type: PERSIST_FINDING_RULE,
    payload: findingRule,
  };
};
export const persistFilterData = (filterData) => {
  return {
    type: PERSIST_FILTER_DATA,
    payload: filterData,
  };
};
export const clearAnomalyRuleFilter = () => {
  return { type: CLEAR_ANOMALY_RULE_FILTER };
};